import styled from "styled-components";

export const StyledStepperHeaderItem = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;

  .step-counter {
    position: relative;
    z-index: 5;
    color: #fdfffc;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 26px;
    height: 26px;
    padding: 10px;
    border-radius: 50%;
    background: #2f2323;
    margin-bottom: 6px;
  }

  &::after {
    position: absolute;
    content: "";
    border-bottom: 5px solid #2f2323;
    width: 100%;
    top: 10px;
    left: 50%;
    z-index: 2;
  }

  &.completed {
    .step-counter {
      background: linear-gradient(
        90deg,
        #f89825 0%,
        #f26322 17.75%,
        #e5333b 46.66%,
        #c81d5e 86.72%,
        #a91e5e 97.37%
      );
    }
    &::before {
      position: absolute;
      content: "";
      border-bottom: 5px solid #4bb543;
      -webkit-border-image: -webkit-gradient(
          linear,
          left top,
          right bottom,
          from(#a91e5e),
          to(#f26322),
          color-stop(0.8, #f26322),
          color-stop(0.2, #a91e5e)
        )
        21 30;
      width: 100%;
      top: 10px;
      left: -50%;
      z-index: 3;
    }
  }

  &:first-child {
    &::before {
      content: none;
    }
  }

  &:last-child {
    &::after {
      content: none;
    }
  }

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

export const StyledStepperHeader = styled.div`
  margin-top: auto;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  margin-top: 20px;
`;
